import React from 'react';
import styled from 'styled-components';
import type { ProductTabUsageModel } from 'autogen/swagger/all';
import BlockList from '../blockList';
import HorizontalVideoCard from './HorizontalVideoCard';

const UsageWrapper = styled.div`
    display: grid;
    grid-template-columns: auto;
    row-gap: 16px;
`;

const StyledHorizontalVideoCard = styled(HorizontalVideoCard)`
    max-width: 480px;
`;

export default function Usage(props: ProductTabUsageModel) {
    const {
        video,
        blockList: { blocks }
    } = props;

    return (
        <UsageWrapper>
            {video ? <StyledHorizontalVideoCard videoModel={video} /> : null}
            <BlockList blocks={blocks} />
        </UsageWrapper>
    );
}
